import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, ref } from 'vue';
import VAForm from '../VAForm/VAForm.vue';
import { VAFormItem } from '../VAForm/extends/typing';
import { VATableRecord } from '../VATable/extends/typing';

// 添加和修改的抽屉
// 接收title, visible, data, formItems
// title有添加和修改，需要接收修改的title中的key


export default /*@__PURE__*/_defineComponent({
  __name: 'VAFormModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  options: {
    type: Object as PropType<Array<VAFormItem>>,
    required: true,
  },
  data: {
    type: Object as PropType<VATableRecord>,
    required: true,
  },
},
  emits: ['close', 'submit'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const form = ref({});

// 初始化表单项，修改时update=false的禁用表单项
const newItems = computed(() => {
  // 点击添加时需要再解除禁用
  const items = props.options as Array<VAFormItem>;
  if (props.title.toString() === '添加')
    return items.map((item) => {
      if (item.update === false && item.disabled) {
        item.disabled = false;
      }
      return item;
    });

  // 若update=false，则禁用表单项
  return items.map((item) => {
    if (item.update === false) item.disabled = true;
    return item;
  });
});

const close = () => {
  emit('close');
};
const submit = () => {
  form.value.formRef.validate().then(() => {
    emit('submit', props.data);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    maskClosable: false,
    width: "500px",
    visible: props.visible,
    onCancel: close,
    title: props.title
  }, {
    extra: _withCtx(() => [
      _renderSlot(_ctx.$slots, "extra")
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "footer", { data: __props.data }, () => [
            _createVNode(_component_a_button, {
              onClick: _withModifiers(close, ["prevent"]),
              size: "small"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              onClick: submit
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("提交 ")
              ])),
              _: 1
            })
          ]),
          _renderSlot(_ctx.$slots, "customFooter", { data: __props.data })
        ]),
        _: 3
      })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "modal-header"),
      _createVNode(VAForm, {
        options: newItems.value,
        data: __props.data,
        ref_key: "form",
        ref: form
      }, _createSlots({ _: 2 }, [
        _renderList(newItems.value, (v) => {
          return {
            name: v.slot,
            fn: _withCtx(({ item, data }) => [
              (v.slot)
                ? _renderSlot(_ctx.$slots, v.slot, {
                    key: 0,
                    item: item,
                    data: data
                  })
                : _createCommentVNode("", true)
            ])
          }
        })
      ]), 1032, ["options", "data"])
    ]),
    _: 3
  }, 8, ["visible", "title"]))
}
}

})